"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../../theme");
theme_1.registerTheme('gauge', {
    stripWidth: 30,
    stripBackColor: '#ddd',
    tickInterval: 20,
    tickLabelPos: 'inner',
    tickLabelSize: 16,
    tickLabelColor: '#aaa',
    tickLineColor: '#aaa',
    subTickCount: 4,
    labelPos: ['50%', '80%'],
    labelColor: '#666',
    labelSize: 30,
});
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/gauge/theme.js
// module id = 907
// module chunks = 37